export const isAlive = () => {
  sessionStorage.setItem("isAlive", "live");
};
